module.exports = __webpack_public_path__ + "static/media/tg7.1cc59366.jpg";